import { useCallback, useMemo } from "react"

import { useBuilderStore } from "../store"

import useHTML from "./useHTML"
import useProp from "./useProp"

/**
 * @param {ReturnType<import("./useCompiler").default>} compiler
 * @param {ReturnType<import("./useTheme").default>} post
 * @param {ReturnType<import("./useListStores").default>} stores
 */

export default function useBuilder({ engine }, post, stores) {
  const { save, publish } = useBuilderStore()

  const editing = useProp()
  const craft = useProp()
  const html = useHTML({ editing, engine, craft })

  const handleSave = useCallback(async () => {
    const { types: { list: types } } = post

    return await save({
      definition: { types },
    })
  }, [save, post])

  const handlePublish = useCallback(async ({ tailwindConfig, meta }) => {
    const compiler = engine.buildTheme(post, stores)
    const files = compiler.buildFiles()

    const { types: { list: types } } = post

    return await publish({
      files,
      definition: { types },
      tailwindConfig,
      meta,
    })
  }, [publish, post, engine, stores])

  return useMemo(() => ({
    editing, html, craft,
    handleSave,
    handlePublish,
  }), [editing, html, craft, handleSave, handlePublish])
}

